import { render, staticRenderFns } from "./InCoursePVMarkList.vue?vue&type=template&id=4c922257&"
import script from "./InCoursePVMarkList.vue?vue&type=script&lang=js&"
export * from "./InCoursePVMarkList.vue?vue&type=script&lang=js&"
import style0 from "./InCoursePVMarkList.vue?vue&type=style&index=0&id=4c922257&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports